import { connect } from 'react-redux'
import React,{ Component } from 'react'
import { ponesacaProducto } from '../actions'

class prodModulo extends Component{
	constructor(props) {
    	super(props);
    	this.state = {
	      cant:0,
	      multiplo:props.prodUnidad
	    }
      	this.ponesaca = this.ponesaca.bind(this)
      	this.cambiaGaleira = this.cambiaGaleira.bind(this)
      	this.itemAct = this.props.itemAct.bind(this)
      	this.changeHandler = this.changeHandler.bind(this)
      	this.timeout =  0;
      	this.textInput = React.createRef();
    }

    componentDidMount() {
    	//console.log(this.props)
	}

	componentDidUpdate(prevProps, prevState){
		if(this.props.carro_temp!=prevProps.carro_temp){
			const opcion_data = this.props.carro_temp.find((prod)=>{
				return prod.id===this.props.item.id
			})
			if(opcion_data){
				if(this.state.cant!=opcion_data.cantidad){
					this.textInput.current.value=opcion_data.cantidad
					this.setState({
						cant:opcion_data.cantidad
					})
				}
			}
		}
	}

  	ponesaca(a,b,event){
  		this.props.imgAct(this.props.item.img+".png")
  		if(b==1){
  			this.itemAct(a,this.state.cant+this.props.prodUnidad)
  			/*this.setState({
  				cant: this.state.cant+this.props.prodUnidad
  			})*/
  		}else{
  			if(this.state.cant>0){	
  				this.itemAct(a, this.state.cant-this.props.prodUnidad)		
				/*this.setState({
	  				cant: this.state.cant-this.props.prodUnidad
	  			})*/
  			}
  		}
  		
      	event.preventDefault()
  	}

  	cambiaGaleira(event){
  		this.props.imgAct(this.props.item.img+".png")
  		event.preventDefault()
  	}

  	changeHandler(event){
  		if(event.target.value!="" && !isNaN(event.target.value)){	
  			var data = 	event.target.value
  			if(this.timeout) clearTimeout(this.timeout);
		    this.timeout = setTimeout(() => {
		  		var cant = Math.round(parseInt(data)/this.state.multiplo)*this.state.multiplo
		  		this.props.imgAct(this.props.item.img+".png")
		  		this.itemAct(this.props.item,cant)
		  		console.log(cant)
		  		/*this.textInput.current.value=cant
		  		this.setState({
			  		cant: cant
			  	})*/
		    }, 300);	
  		}
  		event.preventDefault()
  	}
	//readOnly
	render() {
		return (
		<div className="col-12 col-sm-6 col-md-6 col-lg-3  mb-3">
			<div className="card" >
				<div className="p-2" onClick={this.cambiaGaleira}>
					<img className="card-img-top" src={"https://firebasestorage.googleapis.com/v0/b/veltonaccesos-113f7.appspot.com/o/productos%2F"+this.props.item.img+".png?alt=media"} alt={this.props.item.nombre}/>
				</div>
				<div className="card-body p-2">
					<p className="card-title text-center">{this.props.item.nombre}</p>
					<div className="clearfix d-flex justify-content-between align-items-center">
						<a href="#" onClick={ (e) => this.ponesaca(this.props.item,2,e) } alt="menos" name={this.props.item.id} ><i className="far fa-minus-square fa-lg"></i></a>
						<input defaultValue="0" ref={this.textInput}  className="form-control " style={ { width: "50%",padding:"2px",textAlign:"center",fontSize:"12px" } }  onChange={this.changeHandler} />
						<a href="#" onClick={ (e) => this.ponesaca(this.props.item,1,e) } alt="mas" name={this.props.item.id} ><i className="far fa-plus-square fa-lg"></i></a>
					</div>
				</div>
			</div>
		</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
  return {
      carro: state.productos.carro,
      carro_temp:state.productos.carroTemp
    }
}

const mapDispatchToProps = dispatch => {
  return {
    ponesacaProducto: (item, cantidad) =>{
      dispatch(ponesacaProducto(item, cantidad))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(prodModulo)




// WEBPACK FOOTER //
// ./src/components/prodmod.js